var _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonalizationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "url(#paint0_linear_15498_101260)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0195 7.85729L18.5547 4.62661C17.6586 3.79113 16.1054 3.79113 15.1496 4.62661L6.96533 12.3133C6.48742 12.7589 6.24846 13.3159 6.24846 13.8729C6.24846 14.4299 6.48742 15.0426 6.96533 15.4325L7.08481 15.5439L4.33682 18.1062C3.97838 18.4403 3.91865 18.886 4.09786 19.3316C4.27708 19.7772 4.69525 20 5.17316 20H8.04063C8.51854 20 8.99645 19.8329 9.29514 19.4987L10.3107 18.5518L10.4302 18.6632C10.9081 19.1088 11.5055 19.3316 12.1029 19.3316C12.7003 19.3316 13.2976 19.1088 13.7756 18.6632L22.0195 10.9765C22.9156 10.141 22.9156 8.69276 22.0195 7.85729ZM8.4588 18.7189C8.33932 18.8303 8.16011 18.886 8.04063 18.886H5.17316L7.92115 16.3238L9.47436 17.772L8.4588 18.7189ZM11.2665 17.8834L11.1471 17.772L7.92115 14.7641L7.80167 14.6528C7.62246 14.4299 7.44324 14.1515 7.44324 13.8729C7.44324 13.5944 7.56272 13.3159 7.80167 13.0931L8.51854 12.4247L13.6561 17.2149L12.9392 17.8834C12.4613 18.329 11.7444 18.329 11.2665 17.8834ZM21.1832 10.1967L14.4924 16.4351L9.35488 11.6449L16.0456 5.4064C16.2846 5.23935 16.5833 5.07222 16.882 5.07222C17.1807 5.07222 17.4794 5.18359 17.7183 5.4064L21.1832 8.63708C21.6611 9.0827 21.6611 9.75105 21.1832 10.1967Z",
    fill: "#FEFDFD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15498_101260",
    x1: 13,
    y1: 0,
    x2: 13,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4FFA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55D253"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalizationIcon);
export default __webpack_public_path__ + "static/media/personalization_icon.9ea0fb0c2bed956910135e0857677bf5.svg";
export { ForwardRef as ReactComponent };